<template>
  <div id="app" class="app" @click="closeRouterMore">
    <el-backtop v-if="!isPhone"></el-backtop>
    <el-backtop v-else bottom=10 right=10></el-backtop>
    <div class="appRouter" 
      :class="{ 'notInTop': !isAtTop && this.$store.state.routerTopBack === 1, 'routerTopBack' : this.$store.state.routerTopBack === 2}" 
      v-show="this.$store.state.routerTopShow">
      <div class="routerTitle">
        <div class="routerTag" @click="toIndex">
          首页
        </div>
        <div class="routerTagView">
          <div v-for="(item, index) in routerList.one" :key="index" class="routerTag" 
            @mouseenter="toMorePc(item)" @mouseleave="toMorePc(item)"
            @click.stop="toMore(item)">
            <div class="routerIcon" v-html="item.icon"></div>
            <div class="routerTagContent">{{item.tagName}}</div>
            <transition name="slide-fade">
              <div v-show="routerToMore" class="routerToMoreView" :class="{ 'notInTop': !isAtTop}">
                <div v-for="(item, index) in routerList.two" :key="index" class="routerTag2" @click="toMorePage(item)">
                  <div class="routerIcon" v-html="item.icon"></div>
                  <div class="routerTagContent">{{item.tagName}}</div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <router-view class="routerView"></router-view>
    
    <div class="appFooterAll" :class="{'footerPhone' : isPhone}" v-show="this.$store.state.routerFooterShow">
        <div :class="{'footerMarginPhone' :!isPhone}">ICP备案号: 冀ICP备2023034178号-2</div>
        <div style="display: flex; justify-content: center; align-items: center;">
          <img src="../img/gongan.png" style="width: 20px; height: 20px;">
          公安备案号: 冀公网安备13011102001125号
        </div>
    </div>
  </div>
</template>


<script>
import axios from '../js/axios-interceptor'

export default {
  data() {
    return {
      isPhone: false,
      widthAll: 0,
      routerList: {},     // 一级标题列表
      routerToMore: false,    // 控制标题更多
      isAtTop: true,      // 初始化为页面在顶部

    }
  },
  mounted() {
    // 查询导航栏
    this.selectRouter();

    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    this.isMobileDevice()    // 检测是否为移动端
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听
  },
  methods: {
    // 滑动监听
    handleScroll() {
      if (window.scrollY === 0) {
        if (!this.isAtTop) {
          this.isAtTop = true;
        }
      } else {
        if (this.isAtTop) {
          this.isAtTop = false;
        }
      }
    },
    // 查询菜单
    selectRouter() {
      axios.get("/index/selectRouter").then((res) => {
        if (res.data.code == 1) {
          this.routerList = res.data.data;
        }
      })
    },
    // 打开抽屉
    toMore(res) {
      if (res.tagName == "分类") {
        if (!this.isPhone) {
          return;
        }
        this.routerToMore = !this.routerToMore;
      } else {
        // 证明为普通标题，需要跳转
        this.toMorePage(res);
      }
    },
    toMorePc(res) {
      if (this.isPhone) {
        return;
      }
      if (res.tagName == "分类") {
        this.routerToMore = !this.routerToMore;
      }
    },
    // 跳转详情页
    toMorePage(res) {
      const nowPage = this.$route.path;
      const toPage = '/blog/' + res.alias;
      console.log(res.alias);
      if (res.alias == 'SystemBody') {
        if (nowPage != '/SystemBody') {
          this.$router.push({name: 'systemBody'});
        }
        return;
      }
      if (nowPage !== toPage) {
        this.$router.push({ name: 'blog', params: { type: res.alias } });
      }
    },
    // 跳转首页
    toIndex() {
      if (this.$route.path !== '/') {
          this.$router.push({ name: 'index' });
        }
    },
    isMobileDevice() {
      this.$store.state.userLoginClient = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      this.isPhone = this.$store.state.userLoginClient;
    },
    closeRouterMore() {
      if (this.routerToMore) {
        this.routerToMore = false;
      }
    }

  }
}
</script>

<style scope>
  body {
    margin: 0%;
    scroll-behavior: smooth;
    
  }
  #app {
    font-family: STXihei, "华文细黑", "Microsoft YaHei", "微软雅黑";
    height: 100%;
  }
  /* 导航栏总 */
  .appRouter {
    position: fixed;
    z-index: 10;
    width: 100vw;
    height: 8vh;
    color: #fff;
    display: flex;
    top: 0;
    left: 0;
    font-size: 2vh;
    font-weight: bold;
    background-color: rgba(90, 90, 90, 0);
  }
  .routerTopBack {
    background-color: rgba(255, 255, 255, 0.7) !important;
    color: #000;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    border-bottom-left-radius: 0.3vw;
    border-bottom-right-radius: 0.3vw;
  }
  /* 不在顶部 */
  .notInTop {
    background-color: rgba(217, 217, 217, 0.7) !important;
    color: #000 !important;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }
  /* 导航栏icon */
  .routerIcon {
    width: 30px; 
    height: 30px;
    font-size: 3vh;
    /* border: 1px solid red; */
  }
  /* 导航标签总 */
  .routerTitle {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* border: 1px solid black; */
  }
  /* 导航栏标签 */
  .routerTag {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 15vh;
    /* border: 1px solid blue; */
  }
  /* 导航栏标签文字 */
  .routerTagContent {
    margin-left: 10px;
  }
  /* 导航栏分块2 */
  .routerTagView {
    display: flex;
    /* border: 1px solid red; */
    margin-right: 2vw;
  }
  /* 更多盒子 */
  .routerToMoreView {
    background-color: rgba(10, 10, 10, 0.8);
    color: #fff;
    position: absolute;
    padding-top: 20px;
    top: 8vh;
    right: 0;
    margin-right: 2vw;
  }
  /* 更多 标签 */
  .routerTag2 {
    display: flex;
    align-items: center;
    cursor: pointer;
    /* width: 15vh; */
    padding: 0 20px;
    margin-bottom: 20px;
  }

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity 0.5s ease; /* 仅应用于透明度的过渡效果 */
}

.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0; /* 初始状态和结束状态的透明度 */
}

.appFooterAll {
  width: 100%;
  height: 12vh;
  background-color: #323437;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #fff;
  padding: 1vh 0;
}
.footerPhone {
  flex-direction: column !important;
  align-content: center;
  /* justify-items: center; */
}
.footerMarginPhone {
  margin-right: 100px;
}
</style>
